export enum StockLocationType {
    Warehouse = 'Warehouse',
    Vehicle = 'Vehicle',
    User = 'User',
    Job = 'Job',
    Work = 'Work'
}

export const SelectableStockLocationTypes = Object.values(StockLocationType).filter(type => type !== StockLocationType.Job);
export const HireableStockLocationTypes = [StockLocationType.Warehouse];
